import { completeAssign } from './complete-assign';

const property = {
  completeAssign: completeAssign
};

export default property;
